export default __webpack_public_path__ + "logo.ea36a928.png";